
import axios from "../utils/axiosConfig";
import { Invoice } from "../Interfaces/IReceiptTypes";
import { IGenerateReceiptScreenRequest, IGenerateReceiptScreenResponse, IReceiptRequest } from "../Interfaces/IReceipt";
import { IInvoice } from "../Interfaces/IInvoice";
const { BASE_URL } = require("../utils/urls");
//const BASE_URL="https://panaccoapi-453601304730.asia-south1.run.app";
// Function to fetch invoices from the API
export const getPendingInvoices = async (orgId: string): Promise<Invoice[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/api/invoice/getDueAmountInvoices?orgId=${orgId}`);
    
    if (response.data.success) {
      return response.data.invoices;
    } else {
      console.error("Failed to fetch invoices:", response.data.message);
      return [];
    }
  } catch (error) {
    console.error("Error fetching pending invoices:", error);
    return [];
  }
};
export const createReceipt = async (receiptData: any) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/receipt/createReceipt`, receiptData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data; 
  } catch (error) {
    console.error("Error creating receipt:", error);
    throw error;
  }
};
// export const getReceipts = async (orgID:string) => {
//   try {
//     const response = await axios.get(`${BASE_URL}/api/receipt/getByOrgID`, {
//       params: {orgID},
//     });
//     return response.data.receipts; // Assuming API response contains a "receipts" array
//   } catch (error) {
//     console.error("Error fetching receipts:", error);
//     throw error;
//   }
// };
export const getReceipts = async (
  orgId: string,
  filters?: {
    customerId?:  string;
    referenceId?: string;
    paymentMode?: string;
    page?:        number;
    limit?:       number;
  }
) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/receipt/getByOrgId`, {
      params: {
        orgId,           // ✅ matches backend req.query.orgId
        ...filters,      // optional filters spread in when provided
      },
    });
    return response.data;  // { receipts, pagination }
  } catch (error) {
    console.error("Error fetching receipts:", error);
    throw error;
  }
};
export const generateReceipt = async (data: IReceiptRequest) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/receipt/generateReceipt`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Error generating receipt:", error);
    throw error.response?.data || error;
  }
};
export const generateReceiptByScreen = async (
  data: IGenerateReceiptScreenRequest
): Promise<IGenerateReceiptScreenResponse> => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/receipt/generateReceiptByScreen`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error generating receipt (Receipt Screen):", error);
    throw error.response?.data || error;
  }
};
export const getOutstanding = async (orgId: string,customerId :string): Promise<IInvoice[]> => {
  try {
      const response = await axios.get(`${BASE_URL}/api/invoice/outstanding`, {
      params: { orgId ,customerId},
    });
     if(Array.isArray(response.data.invoices))  {
      return response.data.invoices;
    } else {
      console.error("Failed to fetch pending invoices:", response.data.message);
      return [];
    }
  } catch (error) {
    console.error("Error fetching pending invoices:", error);
    return [];
  }
};